module.exports = __webpack_public_path__ + "img/splicing_prograss_three_s.ad9f80a6.png";